import { FieldSelect, QuickPick, Show } from 'bz-core-controls';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core';
import { bind } from 'bind-decorator';
import { Toggle } from 'bz-core-controls';
import OutlineButton from 'bz-core-controls/controls/general/outline-button';

class AutoFlag extends Component {
  constructor(props) {
    super(props);
    this.state = { flagOpen: false };
  }

  @bind
  set(value) {
    const args = Object.assign({}, this.props.value, value);
    this.props.onChange(args);
  }

  @bind
  onSelect(e) {
    this.set({ operator: e.target.value });
  }

  @bind
  onClick() {
    this.setState({ flagOpen: !this.state.flagOpen });
  }

  @bind
  onToggle(e, v) {
    this.set({ autoFlag: v });
  }

  render() {
    let { subProps, control, store, value, classes } = this.props;
    const { operator, operatorValue, flagColour, flagText } = value || { operator: '=' };
    let { autoFlag } = value || { operator: '=' };
    let { flagOpen } = this.state;

    if (autoFlag == undefined) autoFlag = false;

    let props = {
      value: operatorValue,
      onChange: (v) => this.set({ operatorValue: v })
    };

    let operators = [
      { label: 'Is', value: '=' },
      { label: 'Isnt', value: '!' }
    ];

    let flagButton = 'Select a Flag';
    if (flagText && flagColour) flagButton = flagColour + ': ' + flagText;

    if (control.type === 'number') {
      operators.push({ label: 'Is Less Than', value: '<' });
      operators.push({ label: 'Is More Than', value: '>' });
    }
    let newProps = Object.assign({}, props, subProps);
    // change behaviour of value selector a little...
    newProps.inline = false;
    newProps.required = false;
    newProps['text-if-no'] = false;
    newProps['text-if-yes'] = false;
    newProps.lists = store.lists;
    newProps.lookups = store.lookups;
    newProps.multi = true;

    let element = !!control.control ? control.control : control;
    let Ctrl = !!element.default ? element.default : element;
    const input = <Ctrl {...newProps} />;

    return (
      <div>
        <div className={classes.toggle}>
          <Toggle onChange={this.onToggle} checked={autoFlag} />
        </div>
        <Show if={autoFlag}>
          <div className={classes.selectContainer}>
            <span className={classes.selectText}>When value &nbsp;</span>
            <span>
              <FieldSelect
                fullWidth={false}
                includeNone={false}
                value={operator}
                items={operators}
                valueMember="value"
                displayMember="label"
                onChange={this.onSelect}
              />
            </span>
          </div>

          <div className={classes.buttonRow}>
            {input}
            <OutlineButton label={flagButton} onClick={this.onClick} />
            <QuickPick
              open={flagOpen}
              onChange={this.onChange}
              title={'Select a flag'}
              menu={store.flags}
            />
          </div>
        </Show>
      </div>
    );
  }

  @bind
  onChange(displayName, key) {
    let { flags } = this.props.store;
    let tag = key.substring(0, key.indexOf('.'));
    let colour = key.substring(2, key.indexOf('FLAG'));

    this.set({
      title: flags.main[tag],
      flagText: displayName,
      flagColour: colour
    });
    this.setState({ flagOpen: false });
  }
}

AutoFlag.defaultProps = {
  autoFlag: false,
  value: {
    operator: '=',
    operatorValue: 'None'
  }
};

const styles = {
  toggle: {
    textAlign: 'end'
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  selectText: {
    marginBottom: '10px'
  },
  buttonRow: {
    width: '250px',
    marginTop: '5px'
  }
};

export default withStyles(styles, { name: 'auto-flag' })(AutoFlag);
